import React from 'react'
import { l } from '@manychat/manyui'

import { KnowledgeActionCards } from 'apps/aiAutomation/components/KnowledgeActionCards'
import { SidebarHeader } from 'apps/aiAutomation/components/SidebarHeader'
import { useOpenKnowledgeEditor } from 'apps/aiAutomation/lib/hooks/useOpenKnowledgeEditor'

import cm from './styles.module.css'

export const KnowledgeEntryTypePicker = () => {
  const { openNew } = useOpenKnowledgeEditor()

  return (
    <div className={cm.wrapper}>
      <SidebarHeader title={l.translate('New source')} showBackButton={false} />

      <div className="p-a-md o-auto">
        <p className="m-b text-subheading">{l.translate('What would you like to add?')}</p>

        <KnowledgeActionCards onSelect={(type) => openNew(type, 'training')} />
      </div>
    </div>
  )
}
